import React from 'react';
import Image from '@stone/ui/image/Image';
import { useTranslation } from 'react-i18next';
const ShopByCollectionItem = ({ collection }) => {
    // ANCHOR - HOOKS --------------------------------------------------------------------
    const { t } = useTranslation();
    const imagesUrl = collection === null || collection === void 0 ? void 0 : collection.imagesUrl;
    // ANCHOR - RENDER -------------------------------------------------------------------
    return (React.createElement("a", { className: "shop-by-collection__item", href: collection.pageURL },
        Object.keys(imagesUrl).length > 0 && (React.createElement(Image, { avoidLazy: true, className: "shop-by-collection__item-image", src: imagesUrl.image, srcMobile: imagesUrl.imageMobile, alt: (collection === null || collection === void 0 ? void 0 : collection.altImage) || '' })),
        React.createElement("span", { className: "shop-by-collection__bottom" },
            React.createElement("span", { className: "font__title shop-by-collection__item-title" }, collection.title),
            React.createElement("span", null,
                collection.onlineProducts,
                " ",
                t('label.products')))));
};
export default ShopByCollectionItem;
